// Registry describing which file types the citation preview panel can render, and how.
// Add a new extension here (and a matching viewer) to extend support without touching
// the panel's control flow.
export type PreviewCategory =
  | 'pdf'
  | 'image'
  | 'spreadsheet'
  | 'document'
  | 'presentation'
  | 'text'
  | 'unsupported'

const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'])
const SPREADSHEET_EXTENSIONS = new Set(['csv', 'xls', 'xlsx'])
const DOCUMENT_EXTENSIONS = new Set(['docx'])
const PRESENTATION_EXTENSIONS = new Set(['pptx'])
const TEXT_EXTENSIONS = new Set(['txt', 'log', 'md', 'json'])

export const getFileExtension = (fileName: string): string => {
  if (!fileName || !fileName.includes('.')) return ''
  return fileName.split('.').pop()?.toLowerCase() || ''
}

export const getPreviewCategory = (fileName: string): PreviewCategory => {
  const extension = getFileExtension(fileName)
  if (extension === 'pdf') return 'pdf'
  if (IMAGE_EXTENSIONS.has(extension)) return 'image'
  if (SPREADSHEET_EXTENSIONS.has(extension)) return 'spreadsheet'
  if (DOCUMENT_EXTENSIONS.has(extension)) return 'document'
  if (PRESENTATION_EXTENSIONS.has(extension)) return 'presentation'
  if (TEXT_EXTENSIONS.has(extension)) return 'text'
  return 'unsupported'
}
